import { AppBarProps } from '@material-ui/core/AppBar';
import AppBar from '@material-ui/core/AppBar';
import Grid from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import React from 'react';
import styles from './StyledDialog.module.scss';

export class StyledDialogAppBar extends React.Component<
    AppBarProps & {
        title?: React.ReactNode;
        titleBarLeft?: React.ReactNode;
        titleBarRight?: React.ReactNode;
        headerExtraContents?: React.ReactNode;
        hasStepper?: boolean;
        hasTabs?: boolean;
    }
> {
    public static muiName = 'AppBar';

    public render() {
        const {
            titleBarLeft,
            titleBarRight,
            title,
            headerExtraContents,
            children,
            hasStepper,
            hasTabs,
            ...otherProps
        } = this.props;
        const appBarClass = classNames(styles.appBar, {
            [styles.hasStepper]: this.props.hasStepper,
            [styles.hasTabs]: this.props.hasTabs
        });

        if (!!title || !!titleBarRight || !!titleBarLeft || !!headerExtraContents)
            return (
                <AppBar {...otherProps} position='static' color='primary' elevation={0} className={appBarClass}>
                    <Toolbar>
                        <Grid container direction='row' alignItems='center'>
                            {titleBarLeft && <Grid item>{titleBarLeft}</Grid>}
                            <Grid item xs>
                                <Typography variant='h6' color='inherit'>
                                    {title}
                                </Typography>
                            </Grid>
                            {titleBarRight && <Grid item>{titleBarRight}</Grid>}
                        </Grid>
                    </Toolbar>
                    {headerExtraContents}
                    {children}
                </AppBar>
            );

        return null;
    }
}
